import { useToast } from "../hooks/useToast";
import Toast from "./Toast";

import { useTranslation } from 'react-i18next';
/**
 * ToastContainer — renders stacked toasts at bottom-right (desktop) / bottom-center (mobile).
 * Max 5 toasts stacked. New toasts push old ones up.
 */
export default function ToastContainer() {
  const { t } = useTranslation();
  const { toasts, dismissToast } = useToast();

  if (toasts.length === 0) return null;

  return (
    <div
      className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-[9999] flex flex-col gap-2 max-w-sm w-full pointer-events-none"
      style={{ maxWidth: "calc(100vw - 2rem)" }}
      aria-label="Notifications"
    >
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          id={toast.id}
          type={toast.type}
          title={toast.title}
          description={toast.description}
          onClose={dismissToast}
        />
      ))}
    </div>
  );
}
